import ProjectModel from "../../../models/Project";

/**
 * Resolves when Firestore shows the Import Report doc id (`importReportDocumentId`) or
 * `importReportUnavailable` (report job gave up / empty output). Used so we only navigate
 * into the project once the report exists or is definitively skipped (SW-9080 treatment).
 */
export function waitForNovelImportReportGate(projectId) {
  return new Promise((resolve, reject) => {
    let released = false;
    let proj = null;

    const isReady = (p) => !!(p?.importReportDocumentId || p?.importReportUnavailable);

    const finish = (fn) => {
      if (released) return;
      released = true;
      window.removeEventListener("sudowrite:import-failure", onImportFailure);
      try {
        proj?.release();
      } finally {
        proj = null;
      }
      fn();
    };

    const onImportFailure = (ev) => {
      if (ev.detail?.projectId !== projectId) return;
      // The caller shows ImportFailedDialog; claim the event to avoid a duplicate toast.
      ev.preventDefault();
      const hasImportReport = !!proj?.importReportDocumentId;
      finish(() => {
        const err = new Error("import_failed");
        err.projectId = projectId;
        err.hasImportReport = hasImportReport;
        reject(err);
      });
    };

    window.addEventListener("sudowrite:import-failure", onImportFailure);

    ProjectModel.get(projectId)
      .then((p) => {
        if (released) return;
        if (!p) {
          finish(() => reject(new Error("no_project")));
          return;
        }
        proj = p;
        const check = () => {
          if (released) return;
          if (isReady(proj)) {
            finish(() => resolve());
          }
        };
        check();
        if (released) return;
        proj.subscribe(() => check());
      })
      .catch((err) => {
        finish(() => reject(err));
      });
  });
}
